import { render, staticRenderFns } from "./SpecialSpecialties.vue?vue&type=template&id=18767faf&"
import script from "./SpecialSpecialties.vue?vue&type=script&lang=js&"
export * from "./SpecialSpecialties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports